export default __webpack_public_path__ + "static/media/tractor.ddb03895.gif";